import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ElipsisCell from '../../../../components/TableBox/Cells/EllipsisCell';
import ElipsisText from '../../../../components/ElipsisText';
import Badge from '../../../../components/Badge';
import Button from '../../../../components/Button';
import { RowClassName } from '../../../../enums';
import { TableContext } from '../../../../contexts/TableContext';
import { VALIDATION_FIELD_MAPPING, AUDIT_LOG_EVENT_VARIANT } from '../../../../utils/appConstant';

interface RowProps {
  item: any;
  className?: RowClassName;
  // Passed via rowProps spread from TableBox
  onViewClick: (item: any) => void;
}

const Row: React.FC<RowProps> = ({ item, className, onViewClick }) => {
  const { t } = useTranslation();
  const { headCells } = useContext(TableContext);

  return (
    <tr className={className}>
      {headCells.map((headCell) => {
        switch (headCell.id) {
          case VALIDATION_FIELD_MAPPING.occurredAt:
            return <ElipsisCell key={headCell.id} width={headCell.width} text={item.created_at} />;
          case VALIDATION_FIELD_MAPPING.actor:
            return (
              <ElipsisCell
                key={headCell.id}
                width={headCell.width}
                node={(
                  <div>
                    <ElipsisText width="100%" text={item.causer_name} className="h6 mb-1" />
                    <ElipsisText width="100%" text={item.causer_role || '-'} />
                  </div>
                )}
              />
            );
          case VALIDATION_FIELD_MAPPING.auditEvent:
            return (
              <td key={headCell.id} width={headCell.width}>
                <Badge text={item.event} variant={AUDIT_LOG_EVENT_VARIANT[item.event] ?? 'secondary'} />
              </td>
            );
          case VALIDATION_FIELD_MAPPING.auditEntity:
            return <ElipsisCell key={headCell.id} width={headCell.width} text={item.entity} />;
          case VALIDATION_FIELD_MAPPING.auditModule:
            return <ElipsisCell key={headCell.id} width={headCell.width} text={item.module_name} />;
          case VALIDATION_FIELD_MAPPING.auditSubject:
            return <ElipsisCell key={headCell.id} width={headCell.width} text={item.subject} />;
          case VALIDATION_FIELD_MAPPING.auditDescription:
            return <ElipsisCell key={headCell.id} width={headCell.width} text={item.description} />;
          case VALIDATION_FIELD_MAPPING.auditDetails:
            return (
              <td key={headCell.id} width={headCell.width}>
                <Button
                  className="btn btn-sm btn-icon btn-text-secondary waves-effect waves-light rounded-pill"
                  icon={<i className="ri-eye-line ri-20px" aria-hidden="true"></i>}
                  aria-label={`${t('auditLogs.list.pageTexts.table.view')}: ${item.description}`}
                  onClick={() => onViewClick(item)}
                />
              </td>
            );
          default:
            return <ElipsisCell key={headCell.id} width={headCell.width} text="-" />;
        }
      })}
    </tr>
  );
};

export default Row;
